let isOpenNav = false;
const isRtl = document.documentElement.getAttribute('dir') === 'rtl';

function toggleNav(event) {
  const menuButton = event.currentTarget;
  const menuIcon = menuButton.dataset.menuIcon;
  const closeIcon = menuButton.dataset.closeIcon;

  const overlay = document.getElementById("overlay");
  const header = document.getElementById("byteex-header-nav");
  const search_modal = document.querySelector(".search-modal__form--mobile");

  if (isOpenNav) {
    document.body.style.setProperty("overflow", "auto", "important");
    header.style.position = "fixed";
    document.getElementById("main-nav-container").style.position = "relative";
    document.getElementById("mobile-nav-container").style.display = "none";
    document.getElementById("menu-button-icon").src = menuIcon;
    document.querySelector(".search-modal__form--mobile").style.top = 0;
    overlay.style.display = "none";
    isOpenNav = false;
    return;
  } else {
    header.style.position = "static";
    header.classList.remove("byteex-header-nav-show");
    document.getElementById("main-nav-container").style.position = "fixed";
    document.getElementById("mobile-nav-container").style.display = "block";
    document.getElementById("menu-button-icon").src = closeIcon;
    document.querySelector(".search-modal__form--mobile").style.top = '40px';
    overlay.style.display = "block";
    isOpenNav = true;
    overlay.addEventListener("click", () => {
      document.getElementById("main-nav-container").style.position = "relative";
      document.getElementById("mobile-nav-container").style.display = "none";
      document.getElementById("menu-button-icon").src = menuIcon;
      overlay.style.display = "none";
    });
    document.body.style.setProperty("overflow", "hidden", "important");
    setTimeout(() => {
      document.body.style.setProperty("overflow", "hidden", "important");
    }, 100);
    return;
  }
}

//Info bar slider
const headerSlider = document.querySelector('.byteex-slider');

if (headerSlider) {
  const headerSliderWrapper = headerSlider.querySelector('.byteex-slider-wrapper');
  const headerSlides = headerSliderWrapper.querySelectorAll('.byteex-slider-slide');
  const prevButton = headerSlider.querySelector('.byteex-slider-arrow.prev');
  const nextButton = headerSlider.querySelector('.byteex-slider-arrow.next');

  let currentIndex = 2;
  const slideCount = headerSlides.length;
  let isAnimating = false;

  const firstClone = headerSlides[0].cloneNode(true);
  const lastClone = headerSlides[slideCount - 1].cloneNode(true);

  headerSliderWrapper.appendChild(firstClone);
  headerSliderWrapper.insertBefore(lastClone, headerSlides[0]);

  const updatedheaderSlides = headerSliderWrapper.querySelectorAll('.byteex-slider-slide');
  const updatedSlideCount = updatedheaderSlides.length;

  headerSliderWrapper.style.transform = `translateX(${isRtl ? '200%' : '-200%'})`;

  function updateSlider() {
    const offset = isRtl ? currentIndex * 100 : -currentIndex * 100;
    headerSliderWrapper.style.transition = 'transform 0.3s ease-in-out';
    headerSliderWrapper.style.transform = `translateX(${offset}%)`;
  }

  function showNextSlide() {
    if (isAnimating) return;
    isAnimating = true;
    
    currentIndex++;
    updateSlider();

    if (currentIndex === updatedSlideCount - 1) {
      setTimeout(() => {
        headerSliderWrapper.style.transition = 'none';
        currentIndex = 1;
        headerSliderWrapper.style.transform = `translateX(${isRtl ? '100%' : '-100%'})`;
        isAnimating = false;
      }, 300);
    } else {
      setTimeout(() => {
        isAnimating = false;
      }, 300);
    }
  }

  function showPrevSlide() {
    if (isAnimating) return;
    isAnimating = true;

    currentIndex--;
    updateSlider();

    if (currentIndex === 0) {
      setTimeout(() => {
        headerSliderWrapper.style.transition = 'none';
        currentIndex = updatedSlideCount - 2;
        headerSliderWrapper.style.transform = `translateX(${isRtl ? currentIndex * 100 : -currentIndex * 100}%)`;
        isAnimating = false;
      }, 300);
    } else {
      setTimeout(() => {
        isAnimating = false;
      }, 300);
    }
  }

  let autoScrollInterval = setInterval(showNextSlide, byteex_slider_speed_rotate);

  function resetAutoScroll() {
    clearInterval(autoScrollInterval);
    autoScrollInterval = setInterval(showNextSlide, byteex_slider_speed_rotate);
  }

  nextButton.addEventListener('click', () => {
    clearInterval(autoScrollInterval);
    showNextSlide();
    resetAutoScroll();
  });

  prevButton.addEventListener('click', () => {
    clearInterval(autoScrollInterval);
    showPrevSlide();
    resetAutoScroll();
  });

  headerSlider.classList.remove('opacity-0');
}

document.addEventListener('DOMContentLoaded', () => {
  // Sticky header
  let lastScrollY = window.scrollY;
  const header = document.getElementById('byteex-header-nav');

  window.addEventListener('scroll', () => {
    const announcement = document.getElementById('byteex-announcement-snippet');
    const homepageStickyMenu = document.getElementById('homepage-sticky-menu');

    const currentScrollY = window.scrollY > 0 ? window.scrollY : 0;

    if (lastScrollY < 0) {
      lastScrollY = 0;
    }

    if (currentScrollY < lastScrollY) {
      header.classList.remove('byteex-header-nav-hide');
      header.classList.add('byteex-header-nav-show');

      if (announcement) {
        announcement.classList.remove('byteex-announcement-snippet-hide');
        announcement.classList.add('byteex-announcement-snippet-show');
      }

      if (homepageStickyMenu) {
        homepageStickyMenu.classList.remove('byteex-announcement-snippet-hide');
        homepageStickyMenu.classList.add('byteex-announcement-snippet-show');
      }
    } else {
      header.classList.remove('byteex-header-nav-show');
      header.classList.add('byteex-header-nav-hide');

      if (announcement) {
        announcement.classList.remove('byteex-announcement-snippet-show');
        announcement.classList.add('byteex-announcement-snippet-hide');
      }

      if (homepageStickyMenu) {
        homepageStickyMenu.classList.remove('byteex-announcement-snippet-show');
        homepageStickyMenu.classList.add('byteex-announcement-snippet-hide');
      }
    }

    if (currentScrollY === 0) {
      header.classList.remove('byteex-header-nav-hide');
      header.classList.add('byteex-header-nav-show');

      if (announcement) {
        announcement.classList.remove('byteex-announcement-snippet-hide');
        announcement.classList.add('byteex-announcement-snippet-show');
      }

      if (homepageStickyMenu) {
        homepageStickyMenu.classList.remove('byteex-announcement-snippet-hide');
        homepageStickyMenu.classList.add('byteex-announcement-snippet-show');
      }
    }

    lastScrollY = currentScrollY;
  });

  //Prediactive search
  const openPredictiveSearchBtn = document.querySelector('.search-open__btn');

  openPredictiveSearchBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const predictiveSearch = document.querySelector('predictive-search.search-modal__form--desktop');

    if (predictiveSearch) {
      predictiveSearch.classList.toggle('hidden');
      
      const input = predictiveSearch.querySelector('.search__input');
      if (input) {
        input.focus();
      }
    }
  });

  // Prediactive search mobile
  const buttonMobileSearch = document.querySelector('.button_search_mobile');
  const closeSearchMobile = document.querySelector(
    '.search-action-button--mobile.close__button'
  );

  if (buttonMobileSearch) {
    buttonMobileSearch.addEventListener('click', () => {
      const predictiveSearchMobile = document.querySelector(
        'predictive-search.search-modal__form--mobile'
      );

      if (predictiveSearchMobile) {
        predictiveSearchMobile.style.display = 'flex';

        const input = predictiveSearchMobile.querySelector('.search__input');
        if (input) {
          input.focus();
        }
      }
    });
  }

  if (closeSearchMobile) {
    closeSearchMobile.addEventListener('click', (e) => {
      e.preventDefault();
      const predictiveSearchMobile = e.target.closest(
        '.search-modal__form--mobile'
      );

      if (
        predictiveSearchMobile &&
        predictiveSearchMobile.style.display != 'none'
      ) {
        predictiveSearchMobile.style.display = 'none';
      }
    });
  }

  document.addEventListener('click', (e) => {
    if (
      e.target.classList.contains('search__input') ||
      e.target.classList.contains('menu-button-icon') ||
      e.target.classList.contains('icon-search')
    )
      return;

    const isPredictiveSearch = e.target.closest(
      'predictive-search.search-modal__form--desktop'
    );
    const isMobilePredictiveSearch = e.target.closest(
      'predictive-search.search-modal__form--mobile'
    );
    const predictiveSearch = document.querySelector(
      '.search-modal__form.search-modal__form--desktop'
    );
    const mobilePredictiveSearch = document.querySelector(
      '.search-modal__form.search-modal__form--mobile'
    );

    if (
      !isPredictiveSearch &&
      !document
        .querySelector('predictive-search.search-modal__form--desktop')
        .classList.contains('hidden')
    ) {
      document
        .querySelector('predictive-search.search-modal__form--desktop')
        .classList.add('hidden');
    }
    if (
      !isMobilePredictiveSearch &&
      !document
        .querySelector('predictive-search.search-modal__form--mobile')
        .classList.contains('hidden')
    ) {
      document
        .querySelector('predictive-search.search-modal__form--mobile')
        .classList.add('hidden');
    }
  });

  // Mega menu
  const jpItems = document.querySelectorAll('.desktop_menu_item');
  const movingElement = document.querySelector('.moving-underline');

  jpItems.forEach((item, index) => {
    item.addEventListener('mouseenter', (event) => {
      const width = event.target.offsetWidth - 30;
      const prevWidths = Array.from(jpItems)
        .slice(0, index)
        .reduce((acc, cur) => acc + cur.offsetWidth, 0);
      movingElement.style.width = `${width}px`;
      if (isRtl) {
        movingElement.style.right = `${prevWidths}px`;
      } else {
        movingElement.style.left = `${prevWidths}px`;
      }
    });

    item.addEventListener('mouseleave', () => {
      const activeItem = document.querySelector('.desktop_menu_item.active');
      if (activeItem) {
        const width = activeItem.offsetWidth;
        const prevWidths = Array.from(jpItems)
          .slice(0, index)
          .reduce((acc, cur) => acc + cur.offsetWidth, 0);
        movingElement.style.width = `${width}px`;
        if (isRtl) {
          movingElement.style.right = `${prevWidths}px`;
        } else {
          movingElement.style.left = `${prevWidths}px`;
        }
      }
    });
  });

  // Mobile menu
  const mobileMenuItems = document.querySelectorAll(".mobile-menu-item");  
  mobileMenuItems.forEach(item => {
    item.addEventListener('click', (event) => {
      const clickedElement = event.currentTarget;
      const itemType = clickedElement.dataset.type;
      if (itemType) {
        const activeMenu = document.querySelector(`.${itemType}`);
        if (activeMenu) {  
          activeMenu.style.transform = 'translateX(0)';  
        }
      }
    });
  });

  const mobileItemClose = document.querySelectorAll(".close-menu-item");
  mobileItemClose.forEach(item => {
    item.addEventListener('click', (event) => {
      const clickedElement = event.currentTarget;
      const parentElement = clickedElement.parentElement.parentElement;
      if (parentElement) {
        parentElement.style.transform = 'translateX(100%)';  
      }
    });
  });

  const navMenuItems = document.querySelectorAll(".nav_menu_item");
  const navMenuContents = document.querySelectorAll(".nav_menu_content");
  navMenuContents.forEach(content => {
    content.style.display = "none"; // Initial hiding of all contents
  });

  const overlay = document.getElementById("overlay");
  const movingUnderline = document.querySelector(".moving-underline");
  movingUnderline.style.display = "none";

  navMenuItems.forEach((item, index) => {
    const is_solo_link = item.querySelector('a');

    item.addEventListener("mouseover", () => {
      navMenuContents.forEach(content => {
        content.style.display = "none"; // Hide all contents
      });

      if (!is_solo_link) {
        navMenuContents[index].style.display = "block"; // Show corresponding content
        overlay.style.display = "block";
      }

      if (is_solo_link) {
        overlay.style.display = "none";
      }
      
      movingUnderline.style.display = "block";
    });

    if (is_solo_link) {
      item.addEventListener("mouseleave", () => {
        navMenuContents.forEach(content => {
          content.style.display = "none"; // Hide all contents
        });
  
        overlay.style.display = "none";
        movingUnderline.style.display = "none"; 
      });
    }
  });

  navMenuContents.forEach(content => {
    content.addEventListener("mouseleave", () => {
      navMenuContents.forEach(c => {
        c.style.display = "none"; // Hide all contents on mouseleave
      });
      overlay.style.display = "none";
      movingUnderline.style.display = "none";
    });
  });

  const cartDrawerModal = document.getElementById("byteex_cart_drawer");
  window.addEventListener("click", event => {
    if (event.target === cartDrawerModal) {
      cartDrawerModal.style.display = "none";
      document.documentElement.style.overflow = "unset";
    }
  });

  window.addEventListener("scroll", () => {
    navMenuContents.forEach(content => {
      content.style.display = "none";
    });
    overlay.style.display = "none";
  });
});
